<template>

<main class="py-12 space-y-12">
        <SectionsSectionIntro
            :images="sectionIntro.images"
            :title="sectionIntro.title"
            :teaser="sectionIntro.teaser"
            :text="sectionIntro.text"
        />

        <section>
            <div class="container grid lg:grid-cols-5 gap-12">
                <div class="lg:col-span-3">
                  <h2 class="">
                        Lassen Sie sich von uns beraten
                    </h2>
                    <p class="article-teaser">
                        Bei uns haben Sie immer einen persönlichen Ansprechpartner, bei dem jedes Ihrer Anliegen
                        besprochen und berücksichtigt wird.
                    </p>
                    <p>
                        Von der Planung über die Fertigung und Montage, bis hin zur sicherheitstechnischen Überprüfung
                        Ihrer Spielgräte werden Sie von A bis Z von uns begleitet. Somit ist Ihr persönlicher
                        Fachberater nicht nur geprüfter Sachkundiger für Spielplätze und qualifizierter Spielplatzprüfer
                        nach DIN 79161, sondern sorgt auch für Sicherheit und Ordnung.
                    </p>
                </div>
                <div class="lg:col-span-2">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="BQ4C4885.jpg"
                        alt="Lassen Sie sich von uns Beraten"
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
            </div>
        </section>

        <section>
            <div class="container">
              <h2 class="">
                Gemeinsam planen und am Ende das Ergebnis in AR am eigenen Spielplatz live erleben.
                </h2>
                <p class="article-teaser">
                    Von der 3D-Planung im Konfigurator, über die Sauerland Spielgeräte 3D-Planer-App, bis zur fertigen
                    Spielkombination auf Ihrem Spielplatz. Sauerland Spielgeräte, Ihr Ansprechpartner für echte
                    Live-Erlebnis-Beratung!
                </p>
            </div>
        </section>

        <section>
            <div class="container">
                <NuxtPicture
                    src="Sauerland-Spielgeraete_Erlebnisberatung-2023.jpg"
                    alt="Sauerland-Spielgeräte_Erlebnisberatung-2023.jpg"
                    :img-attrs="{ class: 'rounded-lg' }"
                />
            </div>
        </section>

        <section>
            <div class="container grid lg:grid-cols-5 gap-12">
                <div class="lg:col-span-2">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="BQ4C1535-1.jpg"
                        alt="Lassen Sie sich von uns Beraten"
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
                <div class="lg:col-span-3">
                  <h2 class="">
                        Profis am Werk
                    </h2>
                    <p class="article-teaser">
                        Bevor Sie Ihren fertigen Spielplatz vor Ort abnehmen, wird dieser von Ihrem qualifizierten Fachberater geprüft.
                    </p>
                    <p>
                        Ihr persönlicher Fachberater ist geprüfter Sachkundiger für Spielplätze und qualifizierter Spielplatzprüfer nach DIN SPEC 79161 und berät Sie auch gerne zum Thema Sicherheit.
                    </p>
                    <p>
                        Die DIN SPEC 79161 legt Anforderungen für die Schulung und Prüfung zum qualifizierten Spielplatzprüfer fest. Sie gilt für Personen, die die jährliche Hauptinspektionen von Spielplätzen und Spielgeräten sowie die Inspektionen nach der Fertigstellung eines neuen Spielplatzes nach DIN EN 1176-7 durchführen.
                    </p>
                </div>
            </div>
        </section>

        <section>
            <div class="container grid lg:grid-cols-5 gap-12">
                <div class="lg:col-span-3">
                  <h2 class="">
                        Ersatzteile? Kein Problem!
                    </h2>
                    <p class="article-teaser">
                        Wir garantieren eine mindestens 10 jährige Ersatzteilverfügbarkeit!
                    </p>
                    <p>
                        Wenn Sie einmal Ersatzteile für Ihr Spielgerät benötigen... teilen Sie uns einfach die Identifikationsnummer auf unserer Plakette mit; wir können damit sofort alle Unterlagen und Zeichnungen Ihres Gerätes aufrufen und Ihnen das benötigte Material zusenden.
                    </p>
                </div>
                <div class="lg:col-span-2">
                    <NuxtPicture
                        class="js-fade-in is-added is-visible"
                        src="BQ4C2038-1.jpg"
                        alt="Lassen Sie sich von uns Beraten"
                        :img-attrs="{ class: 'rounded-lg' }"
                    />
                </div>
            </div>
        </section>
    </main>
</template>

<script setup lang="ts">
definePageMeta({
    path: '/Service/Wir-fuer-Sie',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: 'Eine Welt',
    subTitle: 'voller Zusammenarbeit',
};

const sectionIntro = {
    images: ['BQ4C1947.jpg', 'BQ4C5188.jpg', 'BQ4C5809.jpg'],
    title: 'Wir sind für Sie da',
    teaser: 'Unsere Spielplätze bieten alles was das Kinderherz begehrt. Damit das Ganze ermöglicht wird, erhalten Sie bei uns alle Leistungen aus einer Hand.',
    text: '<p>Von der Beratung bis hin zu der Abnahme des fertigen Spielplatzes vor Ort begleiten wir Sie Schritt für Schritt und berücksichtigen dabei all Ihre Wünsche und die Bedürfnisse der Kinder um besonders viel Freude und Sicherheit beim Spielen gewährleisten zu können.</p>'
        + '<p>Sauerland Spielgeräte sind selbstverständlich TÜV-geprüft und überzeugen durch Ihre langanhaltende Qualität und einzigartigem Service. Überzeugen Sie sich selbst!</p>',
};

</script>

<style scoped>

</style>
